import { Injectable } from '@angular/core';

export enum LocalStorageEnum {
  AccessToken = 'accessToken',
  RefreshToken = 'refreshToken',
  Language = 'language',
}

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  public get(key: string): string {
    return localStorage.getItem(key) || '';
  }
  public set(key: string, value: string) {
    localStorage.setItem(key, value);
  }
  public remove(key: string) {
    localStorage.removeItem(key);
  }
  public clear() {
    localStorage.clear();
  }
}
